import React, { useState } from 'react'

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { v4 as uuidv4 } from 'uuid';

import { postDevice } from '../../../../MyApi/sb/device'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddDevice from '../../../../Components/sb/device/deviceStore/AddDevice'




const DevicesStore = () => {
const [ deviceName ,setDeviceName]= useState("")
const [mac, setMac] = useState("")
const RequestId =uuidv4()
const [uuid, setUuid] = useState(RequestId)
const [major , setMajor] =useState("")
const [minor ,setMinor] = useState("")
const [status ,setStatus]= useState("")
const [companyId ,setCompanyId] = useState("")
const [branchId , setBranchId]= useState("")


 const mutation = useMutation("postDevices" , (postData)=>postDevice(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setDeviceName("")
        setMac("")
        setMajor("")
        setMinor("")
        setStatus("")
    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name:deviceName,
        mac,
        uuid,
        major,
        status,      
        sb_company_id:companyId,
        sb_branch_id:branchId, 
        minor,

    })
 } 
 const isDisabled= ()=>{
   return !(deviceName && mac &&uuid && major && status && companyId  &&branchId &&minor  )

 }
  return ( 

    <div>
        <PageHeader title="Add Device" showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddDevice companyId={companyId} mac={mac} deviceName={deviceName} uuid={uuid} major={major} status={status} minor={minor} branchId={branchId} setCompanyId={setCompanyId} setStatus={setStatus} setMinor={setMinor}  setMajor={setMajor} setUuid={setUuid} setMac={setMac} setBranchId={setBranchId} setDeviceName={setDeviceName} />
    </div>
  )
}

export default DevicesStore